<template>
  <div>
    <new-line-recharge v-if="useNewPay"></new-line-recharge>
    <div
      class="saving-wrap"
      v-loading.fullscreen="payLoading"
      element-loading-text="订单支付中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      v-else
    >
      <img class="header-img" src="./images/line-recharge.png" />
      <div class="saving-content">
        <p><span class="step-count">1</span>請輸入要儲值的帳號ID</p>
        <div class="save-uuid">
          <div class="uuid-input">
            <input
              v-model="rechargeUuid"
              maxlength="7"
              placeholder="請輸入您的nicee帳戶ID"
              @input="inputUuid"
            />
          </div>
          <div v-if="rechargeUserInfo" class="user-nickname">
            暱稱：{{ rechargeUserInfo.nickname }}
          </div>
          <div class="get-uuid">在nicee APP「個人中心」頭像下方獲取ID</div>
        </div>
        <p><span class="step-count">2</span>選擇金流</p>
        <div class="saving-paytype">
          <div
            class="saving-paytype-btn"
            :class="{
              checked: paymentType === paymentTypeConfig.tappay
            }"
            @click="selectPaymentType(paymentTypeConfig.tappay)"
          >
            <img class="tappay" src="./images/tapPay.png" />
            <!-- <span class="badge red">限時加贈2%</span> -->
          </div>
          <div
            class="saving-paytype-btn"
            :class="{
              checked: paymentType === paymentTypeConfig.stripe
            }"
            @click="selectPaymentType(paymentTypeConfig.stripe)"
          >
            <img class="spgateway" src="./images/stripe.png" />
            <!-- <span class="badge blue">無贈送</span> -->
          </div>
          <div
            class="saving-paytype-btn"
            :class="{
              checked: paymentType === paymentTypeConfig.paypal
            }"
            @click="selectPaymentType(paymentTypeConfig.paypal)"
          >
            <img class="paypal" src="./images/paypal.png" />
            <!-- <span class="badge red">限時加贈2%</span> -->
          </div>
          <div
            class="saving-paytype-btn"
            :class="{
              checked: paymentType === paymentTypeConfig.funpoint
            }"
            @click="selectPaymentType(paymentTypeConfig.funpoint)"
          >
            <img class="funpoint" src="./images/funPoint.png" />
            <!-- <span class="badge red">限時加贈2%</span> -->
          </div>
          <div class="more" @click="showMore = true" v-show="!showMore">
            <img class="icon-more" src="./images/icon_down.png" alt="" />
            <span>更多付款方式</span>
          </div>

          <template v-if="showMore">
            <div
              class="saving-paytype-btn"
              :class="{
                checked: paymentType === paymentTypeConfig.spgateway
              }"
              @click="selectPaymentType(paymentTypeConfig.spgateway)"
            >
              <img class="spgateway" src="./images/spgateway.png" />
              <!-- <span class="badge blue">無贈送</span> -->
            </div>
            <div
              class="saving-paytype-btn"
              :class="{
                checked: paymentType === paymentTypeConfig.fomopay
              }"
              @click="selectPaymentType(paymentTypeConfig.fomopay)"
            >
              <img class="we-chat" src="./images/weChatPay.png" />
            </div>
          </template>
        </div>
        <template v-if="paymentType !== paymentTypeConfig.fomopay">
          <p><span class="step-count">3</span>儲值方式</p>
          <div class="saving-type">
            <div
              class="saving-btn"
              v-for="(m, i) in paymentMethodsList"
              :key="i"
            >
              <span
                class="number-item"
                :class="{
                  checked: m.code === checkSavingMethod.code,
                  disabled: m.disabled
                }"
                @click="changeSavingMethod(m)"
                >{{ m.name }}</span
              >
            </div>
          </div>
        </template>
        <p>
          <span class="step-count">{{
            paymentType === paymentTypeConfig.fomopay ? 3 : 4
          }}</span
          >選擇儲值金額
        </p>
        <!-- <p class="tip-info" v-if="activitySwitch">
        活動期間每個優惠儲值金額僅限享受一次滿贈優惠
      </p> -->
        <div class="saving-number">
          <div
            class="number-btn"
            v-for="(item, index) in numberArr"
            :key="index"
          >
            <div
              class="number-item"
              :class="{
                checked: item.iapItemId === checkedId
              }"
              @click="changeNumber(item)"
            >
              <img class="gold-img" src="~@/assets/image/icons/gold-icon.png" />
              <span class="get-gold">{{ item.receivedAmount }}</span>
              <span class="user-amount">NT${{ item.paymentAmount }}</span>
              <span
                v-if="activitySwitch ? item.rechargeAward : item.residentAward"
                class="send-gold"
                >送{{
                  activitySwitch ? item.rechargeAward : item.residentAward
                }}幣</span
              >
            </div>
          </div>
        </div>
        <template v-if="showEmail">
          <p class="email-title">電子信箱</p>
          <div class="tip-wrap">
            填寫付款人電子信箱，用以收取支付通知信與電子發票。
          </div>
          <input
            v-model="checkSavingMethod.email"
            class="email-input"
            placeholder="請填寫付款人電子郵箱"
          />
        </template>

        <!-- <div
        class="confrim-save-btn"
        @click="recharge"
      >
        確認儲值
      </div> -->
        <!-- <p class="deadline" v-if="hasGift">
        活動時間：即日起至<span class="dead-time">{{ deadLineDate }}</span
        >截止
      </p> -->
      </div>
      <div class="confrim-save-btn-m" :class="{ addBorder: scrolling }">
        <div
          :id="submitId"
          v-show="paymentType === paymentTypeConfig.paypal"
        ></div>
        <button
          class="c-button"
          :disabled="disableBtn"
          v-show="paymentType != paymentTypeConfig.paypal"
          @click="handleRecharge"
        >
          去儲值
        </button>
      </div>
      <form :action="paymentObj.payUrl" method="post" id="payment-form">
        <input type="hidden" name="MerchantID" :value="paymentObj.storeId" />
        <input type="hidden" name="RespondType" value="JSON" />
        <input type="hidden" name="CheckValue" :value="rechargeInfo.nonce" />
        <input
          type="hidden"
          name="TimeStamp"
          :value="Math.floor(rechargeInfo.createTime / 1000)"
        />
        <input type="hidden" name="Version" value="1.2" />
        <input
          type="hidden"
          name="MerchantOrderNo"
          :value="rechargeInfo.orderNo"
        />
        <input type="hidden" name="Amt" :value="checkedNumber" />
        <input type="hidden" name="LoginType" value="0" />
        <input type="hidden" name="BrowserProcess" value="1" />
        <input type="hidden" name="Email" :value="checkSavingMethod.email" />
        <input type="hidden" name="ItemDesc" value="儲值" />
        <input type="hidden" name="ReturnURL" :value="paymentObj.hostUrl" />
        <!-- 蓝新支付的后台回调通知地址(不知道为什么测试环境，直接商店配置不生效，所以在前端配置)   -->
        <input
          type="hidden"
          name="NotifyURL"
          :value="notifyURL"
          v-if="notifyURL"
        />
        <!-- <input type="hidden" name="CREDIT" value="1" >
      <input type="hidden" name="CVS" value="1" > -->
        <input type="hidden" :name="checkSavingMethod.code" value="1" />
        <input
          type="hidden"
          :name="checkSavingMethod.validity"
          :value="checkSavingMethod.time"
        />
      </form>
      <form
        :action="funPointPaymentObj.payUrl"
        method="post"
        id="funpoint-form"
      >
        <input
          type="hidden"
          name="MerchantID"
          :value="funpointResult.MerchantID"
        />
        <input
          type="hidden"
          name="MerchantTradeNo"
          :value="funpointResult.MerchantTradeNo"
        />
        <input
          type="hidden"
          name="MerchantTradeDate"
          :value="funpointResult.MerchantTradeDate"
        />
        <input
          type="hidden"
          name="PaymentType"
          :value="funpointResult.PaymentType"
        />
        <input
          type="hidden"
          name="TotalAmount"
          :value="funpointResult.TotalAmount"
        />
        <input
          type="hidden"
          name="TradeDesc"
          :value="funpointResult.TradeDesc"
        />
        <input type="hidden" name="ItemName" :value="funpointResult.ItemName" />
        <input
          type="hidden"
          name="ReturnURL"
          :value="funpointResult.ReturnURL"
        />
        <input
          type="hidden"
          name="ChoosePayment"
          :value="funpointResult.ChoosePayment"
        />
        <input
          type="hidden"
          name="CheckMacValue"
          :value="funpointRechargeInfo.nonce"
        />
        <input
          type="hidden"
          name="EncryptType"
          :value="funpointResult.EncryptType"
        />
        <input
          type="hidden"
          name="ClientBackURL"
          :value="funpointResult.ClientBackURL"
        />
      </form>
      <Tappay
        ref="tappay"
        :rechargeUuid="rechargeUuid"
        :price="checkedNumber"
        @submit="tappayRecharge"
      ></Tappay>
    </div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';
import { bindOrder } from '@/api/order';
import Tappay from './tappay.vue';
import newLineRecharge from './new-line-recharge.vue';

export default {
  components: {
    Tappay,
    newLineRecharge
  },
  data() {
    // 支付方式配置
    const paymentTypeConfig = {
      spgateway: 'spgateway',
      funpoint: 'FunPoint',
      fomopay: 'fomopay',
      paypal: 'PayPal',
      tappay: 'TapPay',
      stripe: 'stripe'
    };

    return {
      rechargeUserInfo: null,
      rechargeUuid: '',
      scrolling: false,
      rechargeInfo: {},
      paymentObj: {
        payUrl: '',
        storeId: '',
        nonce: '',
        hostUrl: ''
      },
      funpointResult: {
        EncryptType: 1,
        ItemName: '心約餘額',
        PaymentType: 'aio',
        MerchantTradeDate: '',
        ReturnURL: '',
        MerchantID: '1000031',
        TotalAmount: 12,
        MerchantTradeNo: 'PM1666335865091385',
        TradeDesc: '心約餘額',
        ChoosePayment: 'ALL',
        ClientBackURL: ''
      },
      //FunPoint支付
      funpointRechargeInfo: {},
      funPointPaymentObj: {
        payUrl: '', // FunPoint金流支付url
        hostUrl: '' // 付款完成通知回傳網址
      },
      checkSavingMethod: {
        code: '',
        val: '',
        name: '',
        paymentMethod: '',
        validity: '',
        time: '',
        email: localStorage.getItem('LAST_EMAIL') || ''
      },
      checkedNumber: null,
      checkedId: null,
      numberArr: [],
      activitySwitch: false,
      paymentType: '',
      deadLineTime: 0,
      paypalButton: '', // paypal按钮,
      paypalId: '', //paypal訂單id
      payLoading: false,
      paymentTypeConfig,
      // nicee储值挡位
      niceeItemConfig: {
        tappay: 'LINE_TAB_PAY_CARD',
        funpoint: 'LINE_FUN_POINT',
        paypal: 'PayPal_CheckOut',
        fomopay: 'LinePay',
        // spgateway: 'LineLanXinATM',
        spgateway: 'LinePay', // 臨時設置保持和原來一樣
        stripe: 'LinePay', // 臨時設置保持和原來一樣
        default: 'LinePay'
      },
      showMore: false // 是否顯示更多支付方式
    };
  },
  watch: {
    rechargeUuid: {
      handler: function(uuid) {
        if (uuid.length >= 6) {
          this.clearTimer();
          this.searchUuidTimer = setTimeout(() => {
            this.getUserInfo(uuid);
            this.searchUuidTimer = null;
          }, 500);
        }
        if (this.rechargeUserInfo) {
          if (this.rechargeUserInfo.uuid !== uuid) this.rechargeUserInfo = null;
        }
      },
      immediate: true
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // 支付类型为tappay时，取消支付或是支付失败，为了不显示tappay的支付错误界面，回退两个路由
  //   const { isTappay, status } = to.query;
  //   if (isTappay === 'true' && status) {
  //     history.go(-2);
  //   } else {
  //     next(true);
  //   }
  // },
  created() {
    if (!this.useNewPay) {
      this.funPointPaymentObj.payUrl = process.env.VUE_APP_FUNPOINT;
      this.funPointPaymentObj.hostUrl =
        location.protocol +
        '//' +
        location.host +
        '/saving' +
        '?' +
        'isSuccess=1';
      document.title = 'nicee陪玩-越儲值越動心';
      this.paymentObj.payUrl = process.env.VUE_APP_PAY_URL;
      this.paymentObj.storeId = process.env.VUE_APP_MERCHANTID;
      this.paymentObj.hostUrl =
        location.protocol +
        '//' +
        location.host +
        '/saving' +
        '?' +
        'isSuccess=1';
      if (this.$route.query.redirect) {
        this.paymentObj.hostUrl = decodeURIComponent(
          this.$route.query.redirect
        );
      }
      window.addEventListener('scroll', this.handleScroll, true);
      this.getRechargeUuid();
    }
  },
  mounted() {
    if (!this.useNewPay) {
      this.isSuccess();
      this.selectPaymentType(this.paymentTypeConfig.tappay);
      this.renderButton();
    }
    document.title = 'nicee陪玩-越儲值越動心';
  },
  beforeDestroy() {
    document.title = 'nicee陪玩-台灣最大遊戲陪玩平台-正妹陪玩在線搶單';
    this.clearTimer();
  },
  computed: {
    deadLineDate() {
      let date = new Date(this.deadLineTime);
      return date.getMonth() + 1 + '月' + date.getDate() + '日';
    },
    hasGift() {
      return this.numberArr.some(item => {
        return item.rechargeAwardSwitch;
      });
    },
    disableBtn() {
      return !(
        this.rechargeUserInfo &&
        this.checkSavingMethod &&
        this.checkSavingMethod.code &&
        this.checkedNumber
      );
    },
    paymentMethodsList() {
      if (this.paymentType === this.paymentTypeConfig.spgateway) {
        return [
          {
            code: 'VACC',
            val: '1',
            name: '銀行轉帳',
            paymentMethod: 'LineLanXinATM',
            validity: 'ExpireDate',
            time: ''
          },
          {
            code: 'CREDIT',
            val: '1',
            name: '信用卡',
            validity: 'TradeLimit',
            paymentMethod: 'LineLanXinCreditCard',
            time: 900
          },
          {
            code: 'CVS',
            val: '1',
            name: '超商代碼繳費',
            validity: 'ExpireDate',
            paymentMethod: 'LineLanXinSupermarket',
            time: ''
          }
        ];
      } else if (this.paymentType === this.paymentTypeConfig.funpoint) {
        return [
          {
            code: 'ALL',
            // val: '1',
            name: '信用卡/ATM/...'
            // validity: 'TradeLimit',
            // paymentMethod: 'fomopay',
            // time: ''
          }
        ];
      } else {
        const cardOptions = {
          code: 'CREDIT',
          val: '1',
          name: '信用卡/金融卡',
          validity: 'TradeLimit',
          paymentMethod: '',
          time: 900
        };
        if (this.paymentType === this.paymentTypeConfig.fomopay) {
          cardOptions.paymentMethod = 'LINE_FOMO_WX_WEB';
        }
        if (this.paymentType === this.paymentTypeConfig.paypal) {
          cardOptions.paymentMethod = 'LINE_PayPal_CheckOut';
        }
        if (this.paymentType === this.paymentTypeConfig.tappay) {
          cardOptions.paymentMethod = 'LINE_TAB_PAY_CARD';
        }
        if (this.paymentType === this.paymentTypeConfig.stripe) {
          cardOptions.paymentMethod = 'LINE_StripeCheckOut';
        }
        return [cardOptions];
      }
    },
    // paypal提交按鈕的id
    submitId() {
      return 'submit' + ((Math.random() * 1000) | 0);
    },
    // 蓝新支付后台通知回调地址
    notifyURL() {
      return process.env.VUE_APP_LANXIN_NOTIFYURL;
    },
    // 是否是line储值通道
    isLine() {
      return this.$route.query && this.$route.query.openExternalBrowser == 1;
    },
    showEmail() {
      const list = [
        this.paymentTypeConfig.paypal,
        this.paymentTypeConfig.fomopay,
        this.paymentTypeConfig.stripe
      ];
      return !list.includes(this.paymentType);
    },
    // 是否使用新版收银台
    useNewPay() {
      //灰度測試，尾號為1或3的使用新版收銀台
      // if (this.isLine) {
      //   return false;
      // } else {
      //   const pattern = /[13]$/;
      //   return pattern.test(this.rechargeUuid);
      // }
      return true;
    }
  },
  methods: {
    clearTimer() {
      if (!this.searchUuidTimer) return;
      clearTimeout(this.searchUuidTimer);
      this.searchUuidTimer = null;
    },
    inputUuid(e) {
      if (isNaN(e.data - 0)) {
        this.rechargeUuid = this.rechargeUuid.substring(
          0,
          this.rechargeUuid.length - 1
        );
      }
    },
    getUserInfo(uuid) {
      this.$http
        .get('/user/nickname', {
          uuid
        })
        .then(({ data }) => {
          if (data.uuid === this.rechargeUuid) {
            this.rechargeUserInfo = data;
          }
        })
        .catch(({ code }) => {
          switch (code) {
            case 430: {
              this.$message.error('該用戶不存在，請檢查ID是否正確');
              break;
            }
          }
        });
    },
    getIapList() {
      let paymentMethod = '';
      switch (this.paymentType) {
        case this.paymentTypeConfig.tappay:
          paymentMethod = this.niceeItemConfig.tappay;
          break;
        case this.paymentTypeConfig.funpoint:
          paymentMethod = this.niceeItemConfig.funpoint;
          break;
        case this.paymentTypeConfig.paypal:
          paymentMethod = this.niceeItemConfig.paypal;
          break;
        case this.paymentTypeConfig.fomopay:
          paymentMethod = this.niceeItemConfig.fomopay;
          break;
        case this.paymentTypeConfig.spgateway:
          paymentMethod = this.niceeItemConfig.spgateway;
          break;
        case this.paymentTypeConfig.stripe:
          paymentMethod = this.niceeItemConfig.stripe;
          break;
        default:
          paymentMethod = this.niceeItemConfig.default;
          break;
      }
      this.$http
        .get('/iap/item/list/recharge', {
          paymentMethod: paymentMethod
        })
        .then(({ data }) => {
          if (data && Array.isArray(data.iapItemsVo)) {
            this.deadLineTime = data.datetime;
            this.numberArr = data.iapItemsVo;
            this.activitySwitch = data.activitySwitch;
          }
        });
    },
    handleScroll() {
      var _this = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        //滚动到底部的高度，可以动态获取也可以写死
        _this.scrolling = false;
      } else {
        _this.scrolling = true;
      }
    },
    changeSavingMethod(obj) {
      if (!obj.disabled) {
        this.checkSavingMethod = obj;
        obj.email = this.checkSavingMethod.email || '';
      }
    },
    changeNumber({ paymentAmount, iapItemId }) {
      this.checkedNumber = paymentAmount;
      this.checkedId = iapItemId;
    },
    getHostUrl() {
      if (this.$route.query.redirect) {
        return decodeURIComponent(this.$route.query.redirect);
      }
      return (
        location.protocol +
        '//' +
        location.host +
        '/saving' +
        '?' +
        'isSuccess=1'
      );
    },
    recharge() {
      if (!this.validEmail()) {
        return;
      }
      this.paymentObj.hostUrl =
        this.getHostUrl() +
        `&price=${this.checkedNumber}&uuid=${this.rechargeUuid}`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.checkSavingMethod.paymentMethod,
          email: this.checkSavingMethod.email
        })
        .then(async data => {
          this.rechargeInfo = data.data;
          localStorage.setItem(
            'LAST_EMAIL',
            this.checkSavingMethod.email || ''
          );
          // this.paymentObj.nonce = data.nonce
          if (this.checkSavingMethod.code !== 'CREDIT') {
            let cur = new Date();
            let validDate = new Date(cur.getTime() + 48 * 60 * 60 * 1000);
            let monthper = validDate.getMonth() > 8 ? '' : '0';
            let month = validDate.getMonth() + 1;
            let monthString = monthper + month.toString();
            let datePer = validDate.getDate() > 9 ? '' : '0';
            let dateString = datePer + validDate.getDate().toString();
            let validTime =
              validDate.getFullYear().toString() + monthString + dateString;
            this.checkSavingMethod.time = validTime;
          }
          window.sessionStorage.setItem('LINE_RECHARGE', 1);
          await this.reportPayType(data.data.orderNo);
          this.$nextTick(() => {
            document.querySelector('#payment-form').submit();
          });
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // 验证邮箱必填
    validEmail() {
      if (!this.checkSavingMethod.email) {
        this.$message.error('請輸入您的電子郵箱');
        return false;
      } else if (
        !/^(\w+\.)*\w+@\w+(.\w+)+$/.test(this.checkSavingMethod.email)
      ) {
        this.$message.error('電子郵箱格式不正確');
        return false;
      } else {
        return true;
      }
    },
    //FunPoint金流
    funPointRecharge() {
      if (!this.validEmail()) {
        return;
      }
      this.funPointPaymentObj.hostUrl =
        this.getHostUrl() +
        `&price=${this.checkedNumber}&uuid=${this.rechargeUuid}`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: 'LINE_FUN_POINT',
          successUrl: this.funPointPaymentObj.hostUrl,
          email: this.checkSavingMethod.email
        })
        .then(async ({ data }) => {
          await this.reportPayType(data.orderNo);
          this.funpointRechargeInfo = data;
          this.funpointResult = data.result;
          localStorage.setItem('LAST_EMAIL', this.checkSavingMethod.email);
          this.$nextTick(() => {
            document.querySelector('#funpoint-form').submit();
          });
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
        });
    },
    // tappay支付
    tappayRecharge(submitObj) {
      const { remember, prime, cardId } = submitObj;
      const isDevelopment = process.env.VUE_APP_ENV === 'development'; //是否是開發環境
      this.payLoading = true;
      const successUrl = `${
        isDevelopment ? 'https://test.nicee.tw' : location.origin
      }${location.pathname}?uuid=${this.rechargeUuid}&`;
      const params = {
        uuid: this.rechargeUuid,
        amount: this.checkedNumber,
        iapItemId: this.checkedId,
        paymentMethod: this.checkSavingMethod.paymentMethod,
        tabPalPrime: prime,
        successUrl: successUrl,
        email: this.checkSavingMethod.email
      };
      if (!cardId) {
        params['remember'] = remember;
      }
      this.$http
        .post('/payment/recharge', params)
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            localStorage.setItem('LAST_EMAIL', this.checkSavingMethod.email);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },
    openTappayDialog() {
      if (!this.validEmail()) {
        return;
      }
      this.$refs.tappay.openDialog();
    },
    // 處理tappay支付狀態
    isTappaySuccess() {
      const { isTappay, status } = this.$route.query;
      if (isTappay === 'true' && status) {
        this.$router.go(-2);
      }
    },
    isSuccess() {
      const url = this.$route.query;
      if (url.isSuccess) {
        if (url.isSuccess == 1) {
          this.$message.success('儲值成功');
        } else {
          this.$message.error('儲值失敗');
        }
        this.$adjust('inapp_purchase', {
          type: 'charge',
          chargeType: 'line',
          amount: this.$route.query.price,
          uuid: this.$route.query.uuid
        });
        const query = this.$route.query;
        const newQuery = {};

        Object.keys(query).forEach(key => {
          let filterKeys = ['isSuccess', 'price', 'uuid'];
          if (!~filterKeys.indexOf(key)) {
            newQuery[key] = query[key];
          }
        });

        this.$router.replace({
          name: 'Saving',
          query: newQuery
        });
      }
    },
    //获取uuid
    getRechargeUuid() {
      if (this.$route.query && this.$route.query.uuid) {
        this.rechargeUuid = this.$route.query.uuid;
      }
    },
    // 選擇金流支付方式
    selectPaymentType(paymentType) {
      if (paymentType != this.paymentType) {
        this.paymentType = paymentType;
        this.checkSavingMethod = this.paymentMethodsList[0];
        this.checkSavingMethod.email = localStorage.getItem('LAST_EMAIL');
        this.getIapList();
        this.checkedNumber = null;
        this.checkedId = null;
      }
    },
    // 生成paypal支付按鈕
    renderButton() {
      const paypayScriptConfig = {
        'client-id': process.env.VUE_APP_CLIENT_ID,
        'disable-funding': 'credit,card',
        currency: 'TWD',
        intent: 'authorize'
      };
      // 按鈕相關設置
      const buttonConfig = {
        // 創建paypal訂單
        createOrder: this.createPaypalOrder,
        // 支付成功
        onApprove: this.paypalPaySuccess,
        onError: err => {
          console.warn(err);
          this.$message({
            message: 'paypal支付失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onCancel: err => {
          console.warn(err);
          this.$message({
            message: '已取消paypal支付',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        },
        onClick: async (data, actions) => {
          if (!this.rechargeUuid) {
            this.$message.error('請輸入要儲值的帳號ID');
            return actions.reject();
          }
          if (!this.rechargeUserInfo) {
            this.$message.error('該用戶不存在，請檢查账号ID是否正確');
            return actions.reject();
          }
          if (!this.checkedNumber) {
            this.$message.error('請选择储值金额');
            return actions.reject();
          }
          try {
            this.payLoading = true;
            const result = await this.$http.post('/payment/recharge', {
              uuid: this.rechargeUuid,
              amount: this.checkedNumber,
              iapItemId: this.checkedId,
              paymentMethod: 'PayPal_CheckOut',
              payPalId: 'paypalId'
            });
            if (result && result.data) {
              await this.reportPayType(result.data.orderNo);
              localStorage.setItem('LAST_EMAIL', this.checkSavingMethod.email);
              this.rechargeInfo = result.data;
              return actions.resolve();
            } else {
              throw new Error('创建订单失败');
            }
          } catch (err) {
            this.$message({
              message: '创建订单失败',
              type: 'error',
              customClass: 'paypal-status'
            });
            return actions.reject();
          }
        }
      };
      // 用來渲染按鈕的元素id
      const id = '#' + this.submitId;
      loadScript(paypayScriptConfig)
        .then(paypal => {
          this.paypalButton = paypal.Buttons(buttonConfig);
          this.paypalButton.render(id).catch(error => {
            console.error('failed to render the PayPal Buttons', error);
          });
        })
        .catch(error => {
          console.error('failed to load the PayPal JS SDK script', error);
        });
    },
    // 創建paypal訂單
    async createPaypalOrder(data, actions) {
      return actions.order
        .create({
          purchase_units: [
            {
              // 商品
              amount: {
                currency_code: 'TWD', //新台幣
                value: this.checkedNumber //金額
              },
              invoice_id: this.rechargeInfo.orderNo
            }
          ]
        })
        .then(async orderData => {
          return orderData;
        })
        .catch(() => {
          this.$message({
            message: 'paypal创建订单失败',
            type: 'error',
            customClass: 'paypal-status'
          });
        });
    },
    // 支付成功
    paypalPaySuccess(data, actions) {
      // Authorize the transaction
      actions.order
        .authorize()
        .then(authorization => {
          // Get the authorization id
          var authorizationID =
            authorization.purchase_units[0].payments.authorizations[0].id;
          this.payLoading = false;
          this.$message({
            message: '支付成功',
            type: 'success',
            customClass: 'paypal-status'
          });
          // 充值nicee币
          bindOrder({
            orderId: data.orderID,
            authId: authorizationID,
            orderNo: this.rechargeInfo.orderNo
          });
        })
        .catch(() => {
          this.$message({
            message: 'paypal获取授权失败',
            type: 'error',
            customClass: 'paypal-status'
          });
          this.payLoading = false;
        });
    },
    // fomo支付
    fomopayRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?isFomoPay=true&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&`;
      const cancelUrl = `${location.origin}${location.pathname}?isFomoPay=false&price=${this.checkedNumber}&uuid=${this.rechargeUuid}&`;
      this.$http
        .post('/payment/recharge', {
          uuid: this.rechargeUuid,
          amount: this.checkedNumber,
          iapItemId: this.checkedId,
          paymentMethod: this.checkSavingMethod.paymentMethod,
          successUrl: successUrl,
          cancelUrl: cancelUrl
        })
        .then(async ({ data }) => {
          if (data.result.url) {
            await this.reportPayType(data.orderNo);
            window.open(data.result.url, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    },
    // 处理支付
    handleRecharge() {
      if (this.paymentType === this.paymentTypeConfig.spgateway) {
        this.recharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.funpoint) {
        this.funPointRecharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.tappay) {
        this.openTappayDialog();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.fomopay) {
        this.fomopayRecharge();
        return;
      }
      if (this.paymentType === this.paymentTypeConfig.stripe) {
        this.stripeRecharge();
        return;
      }
    },
    //上报支付渠道
    async reportPayType(orderNo) {
      //deskType 1/新版收银台 2/旧版
      // type. 1/官网包 2/line 3/pcWEB页面
      try {
        return await this.$http.post('/payment/recharge/event/save', {
          deskType: 2,
          type: this.isLine ? 2 : 1,
          uuid: this.rechargeUuid,
          orderNo
        });
      } catch (error) {
        console.log(error);
        return;
      }
    },
    // stripe支付
    stripeRecharge() {
      this.payLoading = true;
      const successUrl = `${location.origin}${location.pathname}?uuid=${this.rechargeUuid}&isStripe=true&`;
      const cancelUrl = `${location.origin}${location.pathname}?uuid=${this.rechargeUuid}&isStripe=false&`;

      const params = {
        uuid: this.rechargeUuid,
        amount: this.checkedNumber,
        iapItemId: this.checkedId,
        paymentMethod: this.checkSavingMethod.paymentMethod,
        successUrl: successUrl,
        cancelUrl: cancelUrl,
        email: this.checkSavingMethod.email
      };
      this.$http
        .post('/payment/recharge', params)
        .then(async ({ data }) => {
          if (data.nonce) {
            await this.reportPayType(data.orderNo);
            localStorage.setItem('LAST_EMAIL', this.checkSavingMethod.email);
            window.open(data.nonce, '_self');
            this.payLoading = false;
          } else {
            this.$message.error('创建订单失败');
            this.payLoading = false;
          }
        })
        .catch(err => {
          if (err.code === 435) {
            this.$message.error('您的帳戶由於觸發平台風控，暫時無法儲值和下單');
          } else if (err.code >= 400 && err.code < 500) {
            this.$message.error('系統異常');
          }
          this.payLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.email-title {
  margin-bottom: 4px !important;
}
.tip-wrap {
  font-size: 14px;
  line-height: 22px;
  color: $color-gray-3;
  margin-bottom: 20px;
}
.email-input {
  width: 432px;
  max-width: 100%;
  background: #f9f9f9;
  border: 1px solid $color-split;
  padding: 12px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: $color-gray-1;
  margin-bottom: 60px;
  &::placeholder {
    color: $color-gray-4;
  }
}
.header-img {
  width: 100%;
  display: block;
}
.curBalance img {
  height: 18px;
  margin: 0 4px 0 7px;
  vertical-align: middle;
}
.gold-counts {
  display: inline-block;
  vertical-align: middle;
  font-style: normal;
}
.gift-num {
  display: inline-block;
  padding: 2px 4px;
  background: #fe7f38;
  border-radius: 0 4px 0 4px;
  font-size: 11px;
  line-height: 1;
  color: #ffffff;
}
.deadline {
  margin-top: 10px;
  font-size: 12px !important;
  line-height: 17px !important;
  color: #636d86 !important;
}
.dead-time {
  color: #fe7f38;
}

.saving-wrap {
  width: 100vw;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 90px;
  .saving-header {
    width: 100%;
    box-sizing: border-box;
    padding: 15px 4.8vw 15px;
    border-bottom: 2px solid #f4f4f4;
    span {
      font-size: 22px;
      color: #222c43;
      font-style: normal;
      font-weight: 600;
    }
    .mobileSaving {
      margin-top: 3.2vw;
      @include flex(flex-start, flex-end);
      line-height: 22px;
      p {
        margin-right: 10px;
        font-size: 14px;
        color: #8c94aa;
      }
      .curBalance {
        color: #08b63a;
        font-size: 16px;
      }
    }
  }
  .saving-content {
    box-sizing: border-box;
    padding: 6.7vw 4.8vw 15px;
    .webSaving {
      display: none;
    }
    p {
      margin-bottom: 5vw;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      @include flex(flex-start);
    }
    .tip-info {
      margin-bottom: 12px;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: red;
      font-weight: bold;
    }
    .step-count {
      display: inline-block;
      border: 2px solid $color-gray-1;
      width: 22px;
      height: 22px;
      @include flex;
      font-weight: 800;
      font-size: 14px;
      border-radius: 50%;
      color: $color-gray-1;
      margin-right: 8px;
    }
    .save-uuid {
      border-bottom: 1px solid $color-split;
      padding-bottom: 28px;
      margin-bottom: 28px;
      .uuid-input input {
        padding: 15px;
        width: 100%;
        background: #f9f9f9;
        border: 1px solid $color-split;
        box-sizing: border-box;
        border-radius: 4px;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: $color-gray-1;
        &::placeholder {
          color: $color-gray-3;
        }
        &:focus {
          background: #ffffff;
          box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        }
      }
      .user-nickname {
        font-size: 13px;
        line-height: 15px;
        margin-top: 10px;
        color: $color-gray-1;
      }
      .get-uuid {
        font-size: 13px;
        line-height: 18px;
        color: $color-gray-3;
        margin-top: 10px;
      }
    }
    .saving-paytype {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 28px;
      padding-bottom: 13px;
      border-bottom: 1px solid $color-split;
      .saving-paytype-btn {
        width: 43.5vw;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #e8eaee;
        margin-bottom: 4vw;
        position: relative;
        &.checked {
          background-color: #fffbd7;
          // background-image: url('./images/icon-check.png');
          border-color: #fed838;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        }
        // &:first-child {
        //   margin-right: ;
        // }
        img {
          &.spgateway {
            width: 96px;
          }
          &.fomopay {
            width: 114px;
          }
          &.paypal {
            width: 94px;
          }
          &.funpoint {
            width: 88px;
          }
          &.tappay {
            width: 94px;
          }
          &.we-chat {
            width: 112px;
          }
        }
        .badge {
          display: flex;
          position: absolute;
          right: -8px;
          top: -32%;
          // width: 44px;
          // height: 20px;
          border-radius: 4px 4px 4px 0;
          // background: rgba(254, 113, 3, 1);
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 12px;
          padding: 2px 4px;
          &.red {
            background: rgb(247, 37, 87);
          }
          &.blue {
            background: rgb(70, 139, 221);
          }
        }
      }
      .more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
      .icon-more {
        width: 18px;
        margin-right: 2px;
      }
    }

    .saving-type {
      // height: 62px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 28px;
      padding-bottom: 13px;
      border-bottom: 1px solid $color-split;
      // .saving-btn:nth-child(2n) {
      //   margin-left: 2vw;
      // }
      .saving-btn {
        // height:40px;
        // width: 120px;
        text-align: center;
        margin-bottom: 4vw;
        cursor: pointer;
        border-radius: 4px;
        span {
          min-width: 33vw;
          max-width: 43.5vw;
          height: 11vw;
          display: flex;
          flex-direction: column;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
    .saving-number {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      .number-btn:nth-child(2n) {
        margin-left: 3.2vw;
      }
      .number-btn {
        line-height: 62px;
        text-align: center;
        background: #f7f7f7;
        border: none;
        margin-bottom: 4vw;
        cursor: pointer;
        border-radius: 4px;
        position: relative;
        .number-item {
          padding: 0 12px;
          .gold-img {
            width: 26px;
            height: 26px;
          }
          .get-gold {
            flex: 1;
            margin-left: 6px;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: $color-gray-1;
            text-align: left;
          }
          .user-amount {
            font-size: 12px;
            color: $color-gray-2;
          }
          .send-gold {
            position: absolute;
            top: 0;
            right: 0;
            padding: 1px 3px;
            border-radius: 0 4px 0 4px;
            background: #f5655a;
            font-weight: 500;
            font-size: 11px;
            line-height: 15px;
            color: #ffffff;
          }
        }
      }
    }
    .confrim-save-btn {
      display: none;
    }
    .number-item {
      @include flex();
      width: 43.5vw;
      height: 62px;
      border-radius: 4px;
      color: #222c43;
      font-size: 14px;
      font-weight: 500;
      background: #fff;
      border: 1px solid #e8eaee;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: top -1px right -1px;
      background-size: 20px;

      &.checked {
        background-color: #fffbd7;
        // background-image: url('./images/icon-check.png');
        border-color: #fed838;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      }

      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
  .confrim-save-btn-m {
    width: 100vw;
    min-height: 90px;
    position: fixed;
    background: #fff;
    bottom: 0;
    padding: 20px 26px 20px 24px;
    .c-button {
      display: block;
      width: 87vw;
      height: 50px;
      line-height: 50px;
      font-weight: 500;
      background: #08b63a;
      color: #fff;
      border-radius: 2px;
      text-align: center;
      cursor: pointer;
      &:disabled {
        background: #f1f4f6 !important;
        color: rgba(99, 103, 134, 0.3) !important;
      }
    }
    .deadline {
      text-align: center;
    }
  }
  .addBorder {
    border-top: 2px solid #f4f4f4;
    box-shadow: 0 0 1px 0 #f4f4f4;
  }
}
</style>

<style>
@media screen and (max-width: 599px) {
  .el-message.paypal-status {
    min-width: 80vw !important;
    top: 45vh !important;
  }
}
</style>
